// extracted by mini-css-extract-plugin
export default {"container":"Reports_container__7jB3I","scrollableContainer":"Reports_scrollableContainer__WOwBd"};